/**
 * Loud, unmissable "not production" banner. Tiled diagonally behind the whole
 * app so there's no way to mistake a local/dev session for prod — but hidden
 * on /overlay, which is composited directly into the broadcast.
 */
import { useLocation } from "react-router-dom";
import { config } from "../lib/config";

const LABELS: Partial<Record<typeof config.stage, string>> = {
  local: "LOCAL",
  dev: "DEV",
};

export function EnvWatermark() {
  const location = useLocation();
  const label = LABELS[config.stage];

  if (!label || location.pathname.startsWith("/overlay")) return null;

  return (
    <div className="env-watermark" aria-hidden="true">
      {Array.from({ length: 48 }, (_, i) => (
        <span key={i}>{label}</span>
      ))}
    </div>
  );
}
